import { useCallback, useEffect, useState } from 'react'

import { AUTH_MODAL_EVENT, MODE } from 'Pods/LazyLoaded/AiSignInModal/constants'

// Bridges the header Log in / Sign up buttons (rendered in a separate
// UnifiedNavigation tree) to the in-page AI sign-in modal. On /ai-3d-model-generator those
// buttons publish AUTH_MODAL_EVENT instead of opening their own popover (see
// UserMenu.isAiStudioPage), mirroring /ai (see ThreeDStudio/useAuthModalTrigger).
// AiSubLanding owns no store, so the open state lives here.
function useAuthModalTrigger() {
  const [signInModalMode, setSignInModalMode] = useState(null)

  useEffect(() => {
    if (typeof App === 'undefined' || !App.events) return undefined

    const handleOpen = (payload) => {
      setSignInModalMode(payload?.mode === MODE.LOGIN ? MODE.LOGIN : MODE.SIGNUP)
    }

    App.events.subscribe(AUTH_MODAL_EVENT, handleOpen)

    return () => {
      const unsub = App.events.unsubscribe || App.events.remove
      unsub?.call(App.events, AUTH_MODAL_EVENT, handleOpen)
    }
  }, [])

  const closeSignInModal = useCallback(() => setSignInModalMode(null), [])

  return { signInModalMode, closeSignInModal }
}

export default useAuthModalTrigger
